import axios from '@axios';

const base = 'api/v1/contacts';

export default {
  getPrisonerContacts(prisonerNumber){
    return axios.get(`${base}/prisoner/${prisonerNumber}`);
  },
  getPrisonerOffsiteContacts(prisonerNumber){
    return axios.get(`${base}/prisoner/${prisonerNumber}/offsite`);
  },
  createContact(dto) {
    return axios.post(`${base}/create-contact`, dto);
  },
  purplePhoneGetContacts() {
    return axios.get(`${base}/web-portal/purple-phone`)
  },
  purplePhoneApprove(id) {
    return axios.put(`${base}/purple-phone/${id}/approve`)
  },
  purplePhoneReject(id, dto) {
    return axios.put(`${base}/purple-phone/${id}/reject`, dto)
  },
};
